import r from"./to-length.js";var e=r,n=function(t){return e(t.length)};export{n as default};
